<template>
    <v-row v-if="canEdit" class="container-sets">
        <!-- TITLE -->
        <v-col cols="12" class="text-center">
            {{ $t('common.edit') }} {{ $t('common.config') }}
        </v-col>
        <!-- DIVIDER -->
        <v-col cols="12" class="py-0">
            <v-divider/>
        </v-col>
        <!-- LABELS -->
        <v-col cols="12">
            <v-row no-gutters>
                <v-col cols="2" class="title-col">
                    {{ $tc('exercises.sets', 1) }}
                </v-col>
                <v-col cols="4" class="title-col" v-if="hasReps">
                    {{ $t('exercises.reps') }}
                </v-col>
                <v-col :cols="hasReps ? 4 : 8" class="title-col">
                    {{ $t('exercises.weight') }}
                </v-col>
                <v-col cols="2" class="title-col">
                    {{ $t('common.delete') }}
                </v-col>
            </v-row>
        </v-col>
        <!-- INPUTS -->
        <v-col cols="12" class="pt-0">
            <v-row v-for="(set,i) in dataSet.sets" :key="i" align="center" dense>
                <v-col cols="2" class="text-center">
                    {{ i + 1 }}
                </v-col>
                <v-col cols="4" v-if="hasReps">
                    <kimsa-text-field
                        :value="getValue(i, 'reps')"
                        @change="setValue($event, i, 'reps')"
                        dense force-value centered-value
                    />
                </v-col>
                <v-col v-if="hasWeight" :cols="hasReps ? 4 : 8">
                    <kimsa-text-field
                        :value="getValue(i, 'weight')"
                        @change="setValue($event, i, 'weight')"
                        dense force-value centered-value
                    />
                </v-col>
                <v-col v-if="hasTime" :cols="hasReps ? 4 : 8">
                    <kimsa-text-field
                        :value="getValue(i, 'time')"
                        @change="setValue($event, i, 'time')"
                        dense force-value centered-value
                    />
                </v-col>
                <v-col cols="2" class="text-center">
                    <v-btn icon color="error" @click="deleteSet(i)" :disabled="loading">
                        <v-icon>$delete</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
        <!-- DIVIDER -->
        <v-col cols="12" class="py-0">
            <v-divider/>
        </v-col>
        <!-- BUTTONS -->
        <v-col cols="6" align="right" class="pr-1">
            <v-btn depressed small color="secondary" @click="addSet" :disabled="loading" class="normal-btn">
                {{ $t('exercises.add_set') }}
            </v-btn>
        </v-col>
        <v-col cols="6" class="pl-1">
            <v-btn depressed small color="primary" class="normal-btn black--text" @click="save" :loading="loading">
                {{ $t('common.save') }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import {db} from "@/utils/Firebase";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";

export default {
    name: "EditSets",
    components: {KimsaTextField},
    props: {
        assignedRoutineId: {
            type: String,
            default: null,
        },
        exerciseId: {
            type: String,
            default: null,
        },
        config: {
            type: Object,
            default: null,
        },
        block: {
            type: [Number, String],
            default: null,
        },
        blocks: {
            type: Array,
            default: null,
        },
        category: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            dataSet: [],
        }
    },
    computed: {
        hasReps(vm = this) {
            return !!vm.config.sets[0].data.find(data => data.name === vm.$t('exercises.reps'))
        },
        hasWeight(vm = this) {
            return !!vm.config.sets[0].data.find(data => data.name === vm.$t('exercises.weight'))
        },
        hasTime(vm = this) {
            return !!vm.config.sets[0].data.find(data => data.name === vm.$t('exercises.time'))
        },
        pageHeight() {
            return document.body.scrollHeight
        },
        canEdit(vm = this) {
            return vm.hasWeight || vm.hasTime
        }
    },
    mounted() {
        const vm = this
        vm.loadDataSet()
    },
    methods: {
        async loadDataSet() {
            const vm = this
            if (!vm.config) return
            vm.dataSet = JSON.parse(JSON.stringify(vm.config))
            if (!vm.hasWeight && vm.category === vm.$t('categories.strong')) {
                let payload = {
                    icon: 'mdi-weight',
                    name: vm.$t('exercises.weight'),
                    short_name: 'short_weight',
                    value: 0,
                }
                vm.dataSet.sets.forEach((set, i) => {
                    vm.config.sets[i].data.push(payload)
                })
            }
        },
        getValue(index, type) {
            const vm = this
            if (!vm.dataSet.sets) return 0
            return vm.dataSet?.sets[index]?.data?.find(data => data.name === vm.$t(`exercises.${type}`))?.value || 0
        },
        setValue(value, index, type) {
            const vm = this
            let valueIndex = vm.dataSet.sets[index].data.findIndex(data => data.name === vm.$t(`exercises.${type}`))
            if (valueIndex >= 0) vm.dataSet.sets[index].data[valueIndex].value = value || 0
        },
        deleteSet(index) {
            const vm = this
            vm.dataSet.sets.splice(index, 1);
        },
        addSet() {
            const vm = this
            let dataSet = JSON.parse(JSON.stringify(vm.dataSet))
            dataSet.sets.push(vm.dataSet.sets[vm.dataSet.sets.length - 1])
            vm.dataSet = dataSet
            vm.$vuetify.goTo(vm.pageHeight)
        },
        async save() {
            const vm = this
            vm.loading = true
            let blocks = JSON.parse(JSON.stringify(vm.blocks))
            let exerciseIndex = blocks[vm.block - 1].exercises.findIndex(ex => ex.id === vm.exerciseId)
            blocks[vm.block - 1].exercises[exerciseIndex].config = JSON.parse(JSON.stringify(vm.dataSet))
            await db.collection('assignedRoutines').doc(vm.assignedRoutineId).update({blocks: blocks})
            vm.toast(vm.$t('exercises.updated_sets'))
            vm.$emit('updatedSet')
            vm.loading = false
        }
    },
}
</script>

<style scoped>

.container-sets {
    background-color: rgba(232, 232, 232, 0.75);
    border: 1px solid rgba(51, 51, 51, 0.25);
    border-radius: 8px;
}

.title-col {
    text-align: center;
    font-weight: bold;
    color: #333333;
}

</style>